import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Switch } from '../../../../Switch';
export function ToggleCell(param) {
    let { checked, disabled, loading, tooltip, intent, bi, onChange, testId } = param;
    return /*#__PURE__*/ _jsx(Switch, {
        bi: bi,
        checked: checked,
        disabled: disabled,
        loading: loading,
        intent: intent,
        tooltip: tooltip == null ? undefined : {
            placement: 'top',
            title: tooltip
        },
        testId: testId,
        onChange: (_, nextChecked)=>onChange(nextChecked)
    });
}
